export const hoThyroidOptions = [
    "TSH(3.84)",
    "TSH 10.6 [ 0.6 - 4.84]",
    "TPO 24.42 0 - 60",
    "T5H (Positive)",
    "T5H (Negative)",
    "T4 (Positive)",
    "T4 (Negative)",
    "T3{163.50} / T4 {10.60} / TSH { 2.34} / NORMAL",
    "T3[99.2]/T4[8.43]/TSH[1.064] NORMAL",
    "T3[98.38] T4[7.85] TSH[3.385] NORMAL",
    "T3[96.23] T4[8.76] TSH[1.568] NORMAL",
    "T3[95]/ T4[11.6] / TSH [0.44] NORMAL",
    "T3[95.8] T4[7.77] TSH[2.892] NORMAL",
    "T3[95.53]T4[6.505]TSH[1.228] NORMAL",
    "T3[94.89] T4[7.26] TSH[2.249] NORMAL",
    "T3[94.14]/T4[7.38]/TSH[4.92]/NORMAL",
    "T3[93.10] T4[7.02] TSH[2.411] NORMAL",
    "T3[92.95]T4[6.36]TSH[1.234] NORMAL",
    "T3[92.92] T4[7.69] TSH[1.3117] NORMAL",
    "T3[92.80] T4[6.42] TSH[3.777] NORMAL",
    "T3[92.34] T4[6.09] TSH[0.76] NORMAL",
    "T3[91] T4[6] TSH[1.81] NORMAL",
    "T3[91.72] T4[8.88] TSH[3.208] NORMAL",
    "T3[91.1]/T4[7.65]/TSH[2.352] NORMAL",
    "T3[90] T4[8.55] TSH[1.33] NORMAL",
    "T3[90] T4[6.4] TSH[4.0] NORMAL",
    " T3[87.21] T4[10.56] TSH[2,866]",
    "T3[87.21] T4[10.56] TSH[2.866] NORMAL",
    "T3[86.71] T4[4.18] TSH[16.424]",
    "T3[85] T4[8.66] TSH[1.44] NORMAL",
    "T3[85] T4[4.3] TSH[1.32] NORMAL",
    "T3[82.67] T4[7.87] TSH[0.892] NORMAL",
    "T3[80.43] T4[8.83] TSH[0.851] NORMAL",
    "T3[80.31]/ T4[8.44]/ TSH[0.890]/ NORMAL",
    "T3[75.85]/T4[6.20]/TSH[2.064] NORMAL",
    "T3[71.23] T4[4.5] TSH[3.41] NORMAL",
    "T3[7.6] T4[16.1] TSH[4.59] NORMAL",
    "T3[63.28] T4[4.5] TSH[1.14] NORMAL",
    "T3[61.47] T4[7.88] TSH[4.6882] NORMAL",
    "T3[6.0] T4[16.0] TSH[1.86] NORMAL",
    "T3[59.84] T4[9.91] TSH[11.211]",
    "T3[4.7] T4[15.2] TSH[3.13] NORMAL",
    "T3[4.4] T4[16.9] TSH[0.286] NORMAL",
    "T3[4.3] T4[13.0] TSH[8.70]",
    "T3[4.3] T4[13.0] TSH[5.09] NORMAL",
    "T3[4.1]/T4[14.7]/TSH[0.487] NORMAL",
    "T3[3.9]T4[17.3]TSH[4.28] NORMAL",
    "T3[3.80]/T4 [0.95]/ TSH [1.274] NORMAL",
    "T3[3.73] T4[0.91] TSH[1.365] NORMAL",
    "T3[3.66] T4[0.80] TSH[3.445] NORMAL",
    "T3[3.32] T4[1.36] TSH[2.12] NORMAL",
    "T3[3.21] T4[1.03] TSH[3.76] NORMAL",
    "T3[3.09] T4[0.93] TSH[3.7746] NORMAL",
    "T3[3.09] T4[0.93] TSH[3.7746]",
    "T3[217.0] T4[9.2] TSH[2.56] NORMAL",
    "T3[216.890]T4[14.100]TSH[5.050]",
    "T3[216.890] T4[14.100] TSH[5.050]",
    "T3[2.84] T4[1.06] TSH[1.64] NORMAL",
    "T3[2.21] T4[0.92] TSH[1.195] NORMAL",
    "T3[2.21] T4[0.92] TSH[1.195]",
    "T3[199.40] T4[12.56] TSH[0.97] NORMAL",
    "T3[191.79] T4[10.94] TSH[1.981] NORMAL",
    "T3[190.0] T4[8.34] TSH[2.29] NORMAL",
    "T3[178.6]/ T4[11.03] / TSH [4.91] NORMAL",
    "T3[169.10] T4[8.30] TSH[2.230] NORMAL",
    "T3[169.0] T4[20.03] TSH[1.935]",
    "T3[156.1] T4[6.70] TSH[2.57] NORMAL",
    "T3[153.38] T4[11.36] TSH[0.003] NORMAL",
    "T3[144.5] T4[8.52] TSH[2.75] NORMAL",
    "T3[143.63] T4[6.62] TSH[2.94] NORMAL",
    "T3[142.0] T4[8.70] TSH[2.32] NORMAL",
    "T3[140.32]T4[10.8]TSH[1.76]NORMAL",
    "T3[137.35] T4[11.31] TSH[1.530] NORMAL",
    "T3[136] T4[6.1] TSH[8.57]",
    "T3[134.0] T4[6.9] TSH[2.550] NORMAL",
    "T3[130.00] T4[10.92] TSH[2.81] NORMAL",
    "T3[129]T4[7.45]TSH[10.800]",
    "T3[128.4] T4[12.88] TSH[0.182] NORMAL",
    "T3[125.6]/T4[7.4]/TSH[0.87] NORMAL",
    "T3[123] T4[5.70] TSH[2.63] NORMAL",
    "T3[123.92] T4[9.59] TSH[2.99] NORMAL",
    "T3[122] T4[10.2] TSH[3.24] NORMAL",
    "T3[122.42] T4[8.03] TSH[0.934] NORMAL",
    "T3[121.2]/T4[11.1]/TSH[1.071] NORMAL",
    "T3[120.63] T4[7.72] TSH[1.910] NORMAL",
    "T3[119.78]/ T4 [8.40]/ TSH[1.668] NORMAL",
    "T3[119.63] T4[6.24] TSH[3.322] NORMAL",
    "T3[119.63] T4[6.24] TSH[3.322]",
    "T3[119.30] T4[8.40] TSH[5.420]",
    "T3[119.22] T4[9.4] TSH[1.089] NORMAL",
    "T3[117] T4[7.7] TSH[1.55] NORMAL",
    "T3[116.90] T4[7.05] TSH[1.769] NORMAL",
    "T3[116.60] T4[6.86] TSH[1.500] NORMAL",
    "T3[116.57] T4[9.4] TSH[3.90] NORMAL",
    "T3[116.0] T4[10.00] TSH[0.637] NORMAL",
    "T3[116.0] / T4 [10.64]/TSH [1.310] NORMAL",
    "T3[114.78] T4[10.86] TSH[2.1638] NORMAL",
    "T3[113.96] T4[7.57] TSH[1.803] NORMAL",
    "T3[113.49] T4[7.90] TSH[6.651]",
    "T3[113.27] T4[8.54] TSH[1.114] NORMAL",
    "T3[112.64] T4[7.33] TSH[12.905]",
    "T3[111.2]/T4[10.7]/TSH[1.094] NORMAL",
    "T3[110] T4[6.75] TSH[4.61] NORMAL",
    "T3[110.93] T4[7.41] TSH[5.335] NORMAL",
    "T3[110.50] T4[7.3] TSH[1.684] NORMAL",
    "T3[110.48] T4[9.17] TSH[1.111] NORMAL",
    "T3[109.6]/T4[9.2]/TSH[1.312] NORMAL",
    "T3[109.24] T4[8.89] TSH[1.895] NORMAL",
    "T3[109.0]/T4[9.7]/TSH[1.604] NORMAL",
    "T3[107.49] T4[7.25] TSH[2.147] NORMAL",
    "T3[107.13] T4[9.46] TSH[4.49] NORMAL",
    "T3[107.0]T4[9.4]TSH[1.613] NORMAL",
    "T3[107.00]T4[8.50]TSH[1.759]NORMAL",
    "T3[106.8] T4[9.4] TSH[1.566] NORMAL",
    "T3[104] T4[7] TSH[1.49] NORMAL",
    "T3[103.61] T4[9.77] TSH[1.627] NORMAL",
    "T3[103.2] T4[8.81] TSH[1.043] NORMAL",
    "T3[102.68] T4[7.45] TSH[1.784] NORMAL",
    "T3[101] T4[7.35] TSH[1.41] NORMAL",
    "T3[101.66] T4[8.76] TSH[1.352] NORMAL",
    "T3[101.66] T4[8.76] TSH[1.05] NORMAL",
    "T3[101.54] T4[7.02] TSH[4.359]",
    "T3[101.14]/T4[9.4]/TSH[0.796]/ NORMAL",
    "T3[101.09] T4[7.68] TSH[4.522] NORMAL",
    "T3[1.920] T4[92.00] TSH[2.290] NORMAL",
    "T3[1.7] T4[113] TSH[2.22] NORMAL",
    "T3[1.42] T4[7.81] TSH[3.76] NORMAL",
    "T3[1.36] T4[8.20] TSH[1.25] NORMAL",
    "T3[1.2] T4[9.0] TSH[2.3] NORMAL",
    "T3[1.20] T4[9.9] TSH[4.424] NORMAL",
    "T3[1.204] T4[7.745] TSH[1.828] NORMAL",
    "T3[1.11] T4[8.49] TSH[1.3808] NORMAL",
    "T3[1.08] T4[9.42] TSH[2.41] NORMAL",
    "T3[0.89] T4[5.32] TSH[7.77]",
    "T3[0.87] T4[7.57] TSH[0.904] NORMAL",
    "T3[0.80] T4[6.0] TSH[1.64] NORMAL",
    "T3[0.694] T4[5.85] TSH[4.91] NORMAL",
    "T3[0.694] T4[5.85] TSH[4.91]",
    "T3[ 98] /T4[7.65]/TSH[0.61] NORMAL",
    "T3(96) /T4(6.3) /TSH(1.98)",
    "T3(94.14) /T4(8.32) /TSH(0.72)",
    "T3(93.05) /T4(9.3) /TSH(2.91)",
    "T3(85.91) /T4(8.30) /TSH(2.432)",
    "T3(72.17) /T4(8.96) /TSH(0.82)",
    "T3(5.63) /T4(18.13) /TSH(1.47)",
    "T3(2.96) /T4(179.40) / TSH(6.48)",
    "T3(148) /T4(10) /TSH(3.60)",
    "T3(135.0) /T4(12.65) /TSH(0.113)",
    "T3(133.54) T4(5.67) TSH(2.37)",
    "T3(129.8) /T4(8.41) /TSH(2.74)",
    "T3(129.1) /T4(7.18) /TSH(3.02)",
    "T3(126) /T4(7.58) /TSH(1.29)",
    "T3(121.6) /T4(.04) /TSH(2.44)",
    "T3(118.1) /T4(9.81) /TSH(4.21)",
    "T3(115) /T4(7.3) /TSH(11.18)",
    "T3(113.93) /T4(7.22) /TSH(3.3716)",
    "T3(112.80) /T4(7.99) /TSH(5.92)",
    "T3(110.61) /T4(8.06) /TSH(4.05)",
    "T3(108) /T4(9) /TSH(0.05)",
    "T3(108) /T4(5.70) /TSH(1077)",
    "T3(106.70) /T4(7.37) /TSH(2.770)",
    "T3(102) /T4(5.5) /TSH(3.19)",
    "T3(100.70) /T4(6.47) /TSH(3.400)",
    "T3(100) /T4(6.6) /TSH(4.44)",
    "T3(1.93) /T4(108.2) /TSH(4.30)",
    "T3(1.74) /T4(10.7) /TSH(3.87)",
    "T3(1.73) /T4(7.6) /TSH(4.15)",
    "T3(1.70) /T4(10.66) /TSH(0.628)",
    "T3(1.67) /T4(9.90) /TSH(2.02)",
    "T3(1.67) /T4(6.0) /TSH(4.28)",
    "T3(1.65) /T4(8.23) /TSH(2.06)",
    "T3(1.63) /T4(10.5) /TSH(1.97)",
    "T3(1.62)/ T4(9.26) /TSH(1.28)",
    "T3(1.56) /T4(8.65) /TSH(3.91)",
    "T3(1.56) /T4(10.6) /TSH(0.01)",
    "T3(1.52) /T4(7.8) /TSH(2.35)",
    "T3(1.52) //T4(8.0) /TSH(2.94)",
    "T3(1.50) /T4(10.0) /TSH(1.01)",
    "T3(1.48) /T4(10.0) /TSH(2.60)",
    "T3(1.47) /T4(8.43) /TSH(4.66)",
    "T3(1.47) /T4(6.6) /TSH(1.00)",
    "T3(1.47) /T4(6.45) /TSH(3.23)",
    "T3(1.41) /T4(7.91) /TSH(2.56)",
    "T3(1.40) /T4(12.0) /TSH(2.49)",
    "T3(1.39) /T4(7.70) /TSH(2.82)",
    "T3(1.38) /T4(7.4) /TSH(2.78)",
    "T3(1.36) /T4(7.0) /TSH(2.11)",
    "T3(1.36) /T4(6.7) /TSH(2.10)",
    "T3(1.34) /T4(7.7) /TSH(3.877)",
    "T3(1.34) /T4(6.3) /TSH(6.04)",
    "T3(1.33) /T4(9.4) /TSH(9.54)",
    "T3(1.33) /T4(8.4) /TSH(4.10)",
    "T3(1.32) /T4(9.1) /TSH(2.56)",
    "T3(1.32) /T4(9.0) /TSH(1.44)",
    "T3(1.32) /T4(7.7) /TSH(1.88)",
    "T3(1.31) /T4(10.0) /TSH(2.23)",
    "T3(1.30) /T4(9.30) /TSH(1.05)",
    "T3(1.30) /T4(9.23) /TSH(1.05)",
    "T3(1.30) /T4(8.2) /TSH(1.83)",
    "T3(1.29) /T4(8.5) /TSH(2.65)",
    "T3(1.28) /T4(8.9) /TSH(3.87)",
    "T3(1.28) /T4(7.8) TSH(1.13)",
    "T3(1.28) /T4(7.8) /TSH(1.13)",
    "T3(1.28) /T4(5.9) /TSH(5.15)",
    "T3(1.27) /T4(9.08) /TSH(5.40)",
    "T3(1.27) /T4(8.2) /TSH(2.39)",
    "T3(1.26) /T4(9.0) /TSH(2.25)",
    "T3(1.26) /T4(8.6) /TSH(1.59)",
    "T3(1.26) /T4(6.3) /TSH(2.42)",
    "T3(1.25) /T4(7.8) /TSH(1.72)",
    "T3(1.25) /T4(6.8) TSH(1.35)",
    "T3(1.24) /T4(8.1) /TSH(2.824)",
    "T3(1.23) /T4(8.3) /TSH(3.93)",
    "T3(1.22) /T4(9.41) /TSH(2.62)",
    "T3(1.22) /T4(9.2) /TSH(2.33)",
    "T3(1.22) /T4(7.6) /TSH(2.02)",
    "T3(1.21) /T4(8.35) /THS(3.40)",
    "T3(1.21) /T4(7.9) /TSH(2.03)",
    "T3(1.20) /T4(9.19) /TSH(0.92)",
    "T3(1.20) /T4(6.9) /TSH(4.78)",
    "T3(1.19) /T4(9.9) /TSH(1.52)",
    "T3(1.18)/T4(6.9) /TSH(1.60)",
    "T3(1.17) /T4(7.5) /TSH(2.14)",
    "T3(1.17) /T4(6.87) /TSH(4.18)",
    "T3(1.15) /T4(9.8) /TSH(9.06)",
    "T3(1.15) /T4(9.4) /TSH(3.118)",
    "T3(1.15) /T4(7.1) /TSH(3.36)",
    "T3(1.14) /T4(9.0) /TSH(2.92)",
    "T3(1.14) /T4(5.1) /TSH(2.46)",
    "T3(1.120 /T4(9.8) TSH(0.30)",
    "T3(1.12) /T4(9.1) TSH(0.62)",
    "T3(1.12) /T4(6.4) /TSH(1.10)",
    "T3(1.12) /T4(6.31) /TSH(2.15)",
    "T3(1.11) /T4(4.3) /TSH(33.36)",
    "T3(1.10) /T4(7.7) /TSH(7.71)",
    "T3(1.08) /T4(7.7) /TSH(1.64)",
    "T3(1.08) /T4(7.57) /TSH(1.86)",
    "T3(1.07) T4(7.2) /TSH(1.849)",
    "T3(1.07) /T4(6.1) /TSH(1.39)",
    "T3(1.07) /T4(11.0) /TSH(3.15)",
    "T3(1.05) /T4(6.77) /TSH(1.42)",
    "T3(1.04) /T4(7.59) /TSH(4.02)",
    "T3(1.04) / T4(7.59) / TSH(4.02)",
    "T3(1.03) /T4(6.61) /TSH(3.44)",
    "T3(1.02) /T4(6.3) /TSH(11.19)",
    "T3(1.01) /T4(9.2) /TSH(2.51)",
    "T3(1.01) /T4(8.1) /TSH(0.55)",
    "T3(1.01) /T4(6.55) /TSH(8.33)",
    "T3(1.00) /T4(8.8) /TSH(2.83)",
    "T3(1.00) /T4(7.30) /TSH(11.8)",
    "T3(0.98) /T4(9.26) /TSH(1.814)",
    "T3(0.98) /T4(6.50) /TSH(2.23)",
    "T3(0.98) /T4(12.3) /TSH(0.73)",
    "T3(0.97) /T4(7.41) /TSH(1.46)",
    "T3(0.93) /T4(7.5) /TSH(1.17)",
    "T3(0.92) /T4(8.78) /TSH(2.50)",
    "T3(0.92) /T4(4.8) /TSH(7.65)",
    "T3(0.908) /T4(5.20) /TSH(3.24)",
    "T3(0.893) /T4(8.97) /TSH(1.83)",
    "T3(0.89) /T4(5.2) /TSH(7.43)",
    "T3(0.86) /T4(8.6) /TSH1.96)",
    "T3(0.85) /T4(6.66) /TSH(3.1952)",
    "T3(0.761) /T4(4.90) /TSH(6.97)",
    "T3(0.71) /T4(4.51) /SH(9.23)",
    "T3(0.596) /T4(6.3) /TSH(0.095)",
    "T3(.10) /T4(6.3) /TSH(1.34)",
    "T3 [90.60] T4 [5.70] T5 [2.730]",
    "T3 [88.4]/ T4 [7.87]/ TSH [2.416] NORMAL",
    "T3 [86.23]/ T4 [5.63] / TSH[1.190]/ NORMAL",
    "T3 [163.50] / T4 [10.60] / TSH [2.34] NORMAL",
    "T3 [154.9]/T4[9.12]/ TSH[3.00] NORMAL",
    "T3 [122.0] /T4 [11.7]/ TSH [0.900] NORMAL",
    "T3 [119] / T4 [10.3] / TSH [1.96] NORMAL",
    "T3 [119.4]/T4[8.68]/ TSH[5.02]",
    "T3 [118] , T4 [ 7.3] , TSH [ 1.984] / NORMAL",
    "T3 [116.80]/ T4 [7.60] / TSH [2.260] NORMAL",
    "T3 [102]/T4 [8.37]/ TSH[1.50]/ NORMAL",
    "T3 [102.3]/ T4 [7.98] / TSH [0.776]",
    "T3 [102.3] / T4[6.74]/ TSH [2.80] NORMAL",
    "T3 [100] T4[8.84] TSH[2.68] NORMAL",
    "T3 [1.56] / T4 [11.2]/ TSH [ 2.27]",
    "T3 [1.55], T4 [76.88] , TSH [2.57] NORMAL",
    "T3 [1.24] , T4 [ 7.90], TSH [3.90] / NORMAL",
    "T3 [1.23] T4 [8.23] TSH[3.60]",
    "T3 [ NEGATIVE]",
    "T3 [ 83.0], T4 [8.40], TSH [1.76]/ NORMAL",
    "T3 [ 147] , T4 [ 7.97], TSH [ 5.26] / NORMAL",
    "T3 [ 115.74], T4 [ 8.99], TSH [ 3.33] / NORMAL",
    "T3 [ 113.5] / T4 [10.1] / TSH [1.538] NORMAL",
    "T3 [ 104]/ T4 [9.3] / TSH[ 2.55] NORMAL",
    "T3 (Positive)",
    "T3 (Negative)",
    "T3 (49.63) /T4(5.7) /TSH(4.39)",
    "T3 (148.98) T4 (8.0) TSH (1.57)",
    "T3 115.2 164 - 182 T4 7.88 6.3 - 9.7 TSH 4.84 0.80 - 5.20",
    "T(1.16) /T4(8.7) /TSH(2.89)",
    "T 3(1.18)/ T4(8.1) /TSH(1.24)",
    "no thyroid abnormality ANTI TPO normal",
    "NAD",
    "hypothyroidism 11.2",
    "hypothyroidism",
    "AUNTY + VE",
];